import { render, staticRenderFns } from "./ebs-transactions.vue?vue&type=template&id=db0fd2f6&"
import script from "./ebs-transactions.vue?vue&type=script&lang=js&"
export * from "./ebs-transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports